import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { Screenshot } from '../../resources/client-issue-resource.service';

export function buildAttachmentForUpload(
  response: { downloadUrl: string; uploadUrl: string; objectKey: string },
  screenshot: Screenshot,
) {
  return {
    ...response,
    blob: screenshot.blob,
    body: {
      s3ObjectKey: response.objectKey,
      filename: screenshot.name,
      type: screenshot.blob.type,
    },
  };
}

export function uploadAttachmentsToS3(
  httpClient: HttpClient,
  attachments: Array<{
    uploadUrl: string;
    blob: Blob;
  }>,
) {
  attachments.forEach(async (attachment) => {
    try {
      await lastValueFrom(
        httpClient.put(attachment.uploadUrl, attachment.blob, {
          headers: { 'Content-Type': attachment.blob.type },
        }),
      );
    } catch (e) {
      console.log(e);
    }
  });
}

export function buildAttachments(screenshots: Screenshot[]) {
  return screenshots.map((screenshot) => ({
    filename: screenshot.name,
    s3ObjectKey: '',
    type: screenshot.blob.type,
    preSignedUrl: screenshot.url,
  }));
}
